/**
* @author Indeform Ltd
* @copyright Copyright 2019, Indeform Ltd
* @version 20200422
* @description Core application initialization file.
* NOTE: DO NOT EDIT WITHOUT PERMISSION
*/


import Component from "./core/component";
import Net from "./core/net";
import UI from "./core/ui";

import SessionTimeout from "./modules/session-timeout";

import Main from "./modules/main";

import ProfileSaveModal from "./modules/modal-window/profile-save-modal";
import ConsultantTermsModal from "./modules/modal-window/consultant-terms-modal";

import LoginSign from "./modules/sign/login/login-sign";
import LoginStatus from "./modules/sign/login/login-status";

import RegisterSign from "./modules/sign/register/register-sign";
import RegisterStatus from "./modules/sign/register/register-status";


class OrthoSSO {
    get net() { return this._net; }
    get ui() { return this._ui; }
    get messaging() { return this._messaging; }
    get history() { return this._history; }
    get tokenHeader() {
        return {
            key: 'X-CSRFToken',
            value: csrfToken
        };
    }

    constructor() {
        this.initConsoleLogOverride();

        this._net = new Net(this);
        let ui = this._ui = new UI(this);

        ui.registerComponent(SessionTimeout);

        ui.registerComponent(Main);
        ui.registerComponent(ProfileSaveModal);
        ui.registerComponent(ConsultantTermsModal);

        // Login signing
        ui.registerComponent(LoginSign);
        ui.registerComponent(LoginStatus);

        // Register signing
        ui.registerComponent(RegisterSign);
        ui.registerComponent(RegisterStatus);
    }


    /**
     * Disables browser's console logging (log, warn, error, info methods).
     * @param {boolean} debug If debug is set to true disable console logging
     * 
     * @note Debugging can be switched on/off in code by setting window.DEBUG.
     * @note It is not recommended to override console. It is better to remove
     * all debugging messages or add debug check to logging statements.
     * @see http://udidu.blogspot.com/2012/12/override-console-functions.html
     * @see https://stackoverflow.com/questions/1215392/how-to-quickly-and-conveniently-disable-all-console-log-statements-in-my-code
     * @see https://stackoverflow.com/questions/7500811/how-do-i-disable-console-log-when-i-am-not-debugging
     */
    initConsoleLogOverride() {
        if (typeof(console) === 'undefined') {
            window.console = {};
            console.log = console.error = console.info = console.debug =
            console.warn = console.trace = console.dir = console.dirxml =
            console.group = console.groupEnd = console.time = console.timeEnd =
            console.assert = console.profile = () => {};
        }

        this._consoleError = console.error;
        this._consoleInfo = console.info;
        this._consoleLog = console.log;
        this._consoleWarn = console.warn;

        console.error = (...args) => {
            if (window.DEBUG) {
                this._consoleError.apply(console, args);
            }
        }
        console.info = (...args) => {
            if (window.DEBUG) {
                this._consoleInfo.apply(console, args);
            }
        }
        console.log = (...args) => {
            if (window.DEBUG) {
                this._consoleLog.apply(console, args);
            }
        }
        console.warn = (...args) => {
            if (window.DEBUG) {
                this._consoleWarn.apply(console, args);
            }
        }
    }
};

new OrthoSSO();



//////////////////
// WEBPACK FOOTER
// ./dev_js/sso/orthosso/orthosso.js
// module id = 338
// module chunks = 0